import React from 'react'
import { compose } from 'recompose'

import { withStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'

import { BaseContext } from '../theme.context'
import { history } from '../../store'

const renderCustomComponent = (props, type, data, i) => {
  const { classes } = props

  switch (type) {
    case 'card':
    default:
      return (
        <Grid xs={12} md={6} lg={4} item key={i.toString()}>
          <Card
            className={classes.boxShadow}
            style={{
              minWidth: 200,
              minHeight: 100,
            }}
          >
            <CardContent>
              <Typography
                className={classes.textOfCard}
                color='textPrimary'
                align='center'
              >
                {data.value}
              </Typography>
              <Divider light />
              <Typography
                className={classes.textOfCard}
                style={{ fontSize: 12 }}
                variant='body2'
                color='textSecondary'
                align='center'
              >
                {data.label}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      )
  }
}

export class WidgetsContainer extends React.PureComponent {
  static contextType = BaseContext

  componentDidMount() {
    this.context.onChangeColor()
    this.context.onChangeleftButton(true)
    this.context.onChangeleftButton(
      true,
      null,
      history.goBack,
    )
  }

  render() {
    const { history: { location: { state } }, classes } = this.props
    const { data: { links, file_date: fileDate } } = state

    return (
      <Container fixed>
        {fileDate && (
          <Typography
            className={classes.fileUpdate}
            variant='caption'
            color='textSecondary'
          >
            {`Actualizado: ${fileDate}`}
          </Typography>
        )}
        {links.map((section, i) => (
          <Card
            key={i.toString()}
            className={[classes.boxShadow, classes.cardContainer]}
          >
            <CardHeader
              className={classes.cardHeader}
              title={section.title}
              disableTypography
            />
            <CardContent>
              <Grid
                container
                spacing={4}
                // alignContent='center'
                // alignItems='center'
                direction='row'
              >
                {section.metrics.map((metric, i) => renderCustomComponent(this.props, section.type, metric, i))}
              </Grid>
            </CardContent>
          </Card>
        ))}
      </Container>
    )
  }
}

export default compose(
  withStyles({
    boxShadow: {
      boxShadow: '0px 2px 1px -1px rgba(3,176,238,0.2), 0px 1px 1px 0px rgba(3,176,238,0.14), 0px 1px 3px 0px rgba(3,176,238,0.12)',
    },
    fileUpdate: {
      position: 'absolute',
      right: 30,
      marginTop: 10,
    },
    title: {
      marginTop: 25,
      marginBottom: 30,
    },
    cardHeader: {
      backgroundColor: '#03B0EE',
      color: '#FFF',
      fontWeight: 'bold',
    },
    cardContainer: {
      backgroundColor: 'white',
      marginTop: 35,
      marginBottom: 35,
    },
    textOfCard: { padding: 10 },
  }),
)(WidgetsContainer)
